import {Store,Module,ActionContext} from 'vuex'
import {ListModule, ListState, ListStateItem, ListModuleItem} from '@/store/shared'
import Customer from './entity'
import {$http} from '@/lib'
import {PageResult} from '@/store/shared/entity';

interface CustomerState extends ListStateItem<Customer>{
    editCustomer:Customer;
 
    customerList: Array<any>;
    businessGroupList:Array<any>;
}
class CustomerModule extends ListModuleItem<CustomerState,any,Customer>{

    constructor() {
        super();
        Object.assign(this.state, this.overrideState);
        Object.assign(this.mutations, this.overrideMutations);
    }

    overrideState={
        editCustomer:new Customer(),
        customerList: new Array<any>(),
        businessGroupList:new Array<any>(),

    }

    actions={
        async getAll(context:ActionContext<CustomerState,any>,payload:any){
            context.state.table.loading=true;
            let reponse=await $http.get('/services/app/Customer/GetAll',{params:payload.data});
            context.state.table.loading=false;
            let page=reponse.data.result as PageResult<Customer>;
            context.state.table.totalCount=page.totalCount;
            context.state.table.list=page.items;
        },
        async create(context:ActionContext<CustomerState,any>,payload:any){
            await $http.post('services/app/Customer/Create',payload.data);
        },
        async update(context:ActionContext<CustomerState,any>,payload:any){
            await $http.put('services/app/Customer/Update',payload.data);
        },
        async delete(context:ActionContext<CustomerState,any>,payload:any){
            await $http.delete('services/app/Customer/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<CustomerState,any>,payload:any){
            let reponse=await $http.get('services/app/Customer/Get?Id='+payload.id);
            context.state.editCustomer = reponse.data.result;
            return reponse.data.result;
        },
        async getCustomerList(context:ActionContext<CustomerState,any>){
            
            let reponse = await $http.get('services/app/Customer/GetCustomerOption');
            context.state.customerList = reponse.data.result;
            
        },
        async getBusinessGroupList(context:ActionContext<CustomerState,any>){
            
            let reponse = await $http.get('services/app/Customer/GetBusinessGroupList');
            context.state.businessGroupList = reponse.data.result;
            
        },
    };
    overrideMutations={
        edit(state:CustomerState,customer:Customer){
            state.editCustomer=customer;
        }
    }
}
const customerModule=new CustomerModule();
export default customerModule;